/** Saudi VAT: 15 digits, first and last digit must be 3. */
export const SAUDI_VAT_PATTERN = /^3\d{13}3$/;

export function isValidSaudiVat(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return true;
  return SAUDI_VAT_PATTERN.test(trimmed);
}

export function digitsOnlyVatInput(raw) {
  return String(raw ?? "").replace(/\D/g, "").slice(0, 15);
}
